import { Injectable } from "@angular/core";
import { BaseApiService } from "../shared/_base.api.service";

import { PagedApiResponse } from "../../utils/types/shared/_paged-api-response.type";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { App } from "../../utils/types/admon/app.type";
import { AppMapper } from "../../utils/mappers/admon/app.mapper";
import { FilterType } from "../../utils/types/shared/_filter.type";
import { COMPANY_OPERATOR_ENDPOINTS } from "../../components/mediaManager/admon/company/company-endpoints";
import { ShortCodeMapper } from "../shared/sharedcatalog.service";
import { ShortCode } from "../../utils/types/shared/shortcode.type";
import { HttpParams } from "@angular/common/http";

@Injectable()
export class CompanyOperatorService extends BaseApiService<App> {
    model = App;
    mapper = new AppMapper();

    shortCodeMapper = new ShortCodeMapper();
    apiEndPoint: any = COMPANY_OPERATOR_ENDPOINTS;

    getList(
        filter: FilterType,
        companyId?: number
    ): Observable<PagedApiResponse<App>> {
        let params = new HttpParams();
        params = params.append("offset", filter.offset);
        params = params.append("limit", filter.limit);

        return this.http
            .get(
                this.apiEndPoint.list.replace(
                    "{companyId}",
                    companyId.toString()
                ),
                {
                    params,
                }
            )
            .pipe(
                map((res) => {
                    return this.sharedMapper.mapPagedApiResponse(
                        res,
                        this.mapper.mapList,
                        this.model
                    );
                })
            );
    }

    getShortCodesList(
        companyId: number,
        operatorId: number
    ): Observable<PagedApiResponse<ShortCode>> {
        return this.http
            .get(
                this.apiEndPoint.list_short_codes
                    .replace("{companyId}", companyId.toString())
                    .replace("{operatorId}", operatorId.toString())
            )
            .pipe(
                map((res) => {
                    return this.sharedMapper.mapPagedApiResponse(
                        res,
                        this.shortCodeMapper.mapList,
                        ShortCode
                    );
                })
            );
    }
}
